import axios, { AxiosResponse } from "axios";
import { IApiResponseT } from "../models/apiresponse";
import { ErrorLogDto } from "../models/errorlog";

const logApi = axios.create({baseURL: process.env.REACT_APP_LOG_URL});
const responseBody = <T> (response:AxiosResponse<T>) => response.data;
const logRequest = {
    post: <T>(url: string, body: {}) => logApi.post<T>(url,body).then(responseBody),
};

const ErrorLogWS = {
    addLog: (log: ErrorLogDto) => logRequest.post<IApiResponseT<boolean>>('/errorlog/new',log),
};

export default ErrorLogWS;